var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-2.829,14.829c1.56,1.56,4.098,1.56,5.657,0,.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414c-.914.915-2.055,1.46-3.243,1.659v1.098c0,.552-.448,1-1,1s-1-.448-1-1v-1.098c-1.188-.199-2.328-.744-3.243-1.659-2.339-2.339-2.339-6.146,0-8.485.914-.915,2.055-1.46,3.243-1.659v-1.098c0-.552.448-1,1-1s1,.448,1,1v1.098c1.188.199,2.328.744,3.243,1.659.391.391.391,1.023,0,1.414s-1.023.391-1.414,0c-1.56-1.56-4.098-1.56-5.657,0-.755.755-1.171,1.76-1.171,2.829s.416,2.073,1.171,2.829Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.59d93d3320f1d014d8d14dfe88214c6e.svg";
export { ForwardRef as ReactComponent };